import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.access');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-access',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.access/view.scss */
:host {
  display: block;
  min-height: 100%;
}

.auth-shell {
  min-height: 100dvh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px 20px;
  background: #ffffff;
  position: relative;
  overflow: auto;
}

.auth-transition {
  position: absolute;
  inset: 0;
  background: #ffffff;
  opacity: 0;
  pointer-events: none;
  z-index: 8;
  transition: opacity 0.32s ease;
}

.auth-transition--active {
  opacity: 1;
}

.auth-shell__inner {
  width: 100%;
  min-height: 100dvh;
  position: absolute;
  inset: 0;
  box-sizing: border-box;
  padding: 32px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transform: translateY(18px) scale(0.985);
  pointer-events: none;
  transition: opacity 0.34s ease, transform 0.36s ease;
  z-index: 4;
}

.auth-shell__inner--active {
  opacity: 1;
  transform: translateY(0) scale(1);
  pointer-events: auto;
}

.auth-panel {
  width: min(100%, 875px);
  min-height: 650px;
  padding: 48px 36px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  border-radius: 28px;
  border: 1px solid rgba(255, 255, 255, 0.8);
  background: rgba(255, 255, 255, 0.78);
  backdrop-filter: blur(14px);
  box-shadow: 0 30px 60px rgba(15, 23, 42, 0.12);
}

.auth-panel__header {
  margin-top: 0;
  width: 100%;
  text-align: center;
}

.auth-panel__title {
  margin: 0;
  color: #111111;
  font-size: 34px;
  line-height: 1.1;
  font-weight: 800;
  letter-spacing: 0;
}

.auth-form {
  width: min(100%, 488px);
  margin: 64px auto 0;
  text-align: left;
}

.auth-form__row {
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid rgba(209, 213, 219, 0.9);
  background: #ffffff;
}

.auth-form__row--spaced {
  margin-top: 3px;
}

.auth-form__label {
  display: block;
  width: 100%;
  padding: 14px 8px 8px;
  color: #c4c7cc;
  font-size: 16px;
  font-weight: 600;
  box-sizing: border-box;
  text-align: left;
}

.auth-inline-field {
  display: flex;
  align-items: center;
  gap: 10px;
  padding-right: 8px;
}

.auth-form__input {
  width: 100%;
  height: 42px;
  padding: 0 8px 8px;
  border: 0;
  background: #ffffff;
  color: #111827;
  font-size: 16px;
  outline: none;
}

.auth-form__input:-webkit-autofill,
.auth-form__input:-webkit-autofill:hover,
.auth-form__input:-webkit-autofill:focus,
.auth-form__input:-webkit-autofill:active {
  -webkit-text-fill-color: #111827;
  -webkit-box-shadow: 0 0 0 1000px #ffffff inset;
  box-shadow: 0 0 0 1000px #ffffff inset;
  transition: background-color 9999s ease-out 0s;
}

.auth-form__input--inline {
  flex: 1;
}

.auth-form__input::placeholder {
  color: #d1d5db;
}

.auth-inline-button {
  height: 38px;
  padding: 0 14px;
  border-radius: 999px;
  background: rgba(51, 65, 85, 0.08);
  color: #334155;
  font-size: 10px;
  font-weight: 700;
  text-align: center;
  white-space: nowrap;
}

.auth-inline-button:disabled,
.auth-submit:disabled {
  opacity: 0.55;
  cursor: default;
}

.auth-feedback {
  padding: 0 8px 12px;
  font-size: 10px;
  font-weight: 600;
}

.auth-feedback--success {
  color: #059669;
}

.auth-feedback--error {
  color: #dc2626;
}

.auth-submit {
  width: 100%;
  height: 52px;
  margin-top: 18px;
  background: #334155;
  color: #ffffff;
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 0;
  text-align: center;
}

.auth-panel__links {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 18px;
  margin-top: 36px;
  width: 100%;
  color: #111111;
  flex-wrap: wrap;
}

.auth-panel__link {
  color: #111111;
  font-size: 16px;
  font-weight: 500;
}

.auth-panel__link--accent {
  font-weight: 700;
}

.auth-panel__divider {
  width: 1px;
  height: 26px;
  background: rgba(209, 213, 219, 0.9);
}

@media (max-width: 960px) {
  .auth-shell,
  .auth-shell__inner {
    padding: 20px 16px 28px;
  }
  .auth-panel {
    min-height: 610px;
    padding: 40px 24px;
  }
  .auth-panel__header {
    margin-top: 0;
  }
  .auth-form {
    margin-top: 52px;
  }
}
@media (max-width: 640px) {
  .auth-shell,
  .auth-shell__inner {
    padding: 16px 14px 24px;
  }
  .auth-panel {
    min-height: 560px;
    padding: 36px 18px;
  }
  .auth-panel__title {
    font-size: 28px;
  }
  .auth-form {
    width: 100%;
    margin-top: 42px;
  }
  .auth-form__label {
    padding-top: 14px;
    font-size: 14px;
  }
  .auth-form__input {
    height: 40px;
    font-size: 14px;
  }
  .auth-inline-field {
    flex-direction: column;
    align-items: stretch;
    gap: 6px;
    padding-right: 0;
  }
  .auth-inline-button {
    align-self: flex-start;
    margin: 0 8px 10px;
  }
  .auth-submit {
    height: 48px;
    font-size: 16px;
  }
  .auth-panel__links {
    gap: 14px;
  }
  .auth-panel__link {
    font-size: 14px;
  }
}`],
})
export class PageAccessComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public view: string = 'login';
    public isTransitioning: boolean = false;
    public checking: boolean = false;
    public submitting: boolean = false;
    public idChecked: boolean = false;
    public idAvailable: boolean = false;

    public loginData: any = {
        email: '',
        password: ''
    };

    public signupData: any = {
        name: '',
        email: '',
        password: '',
        passwordConfirm: ''
    };

    public async ngOnInit() {
        await this.service.init();
        let check = await this.service.auth.check();
        if (check) return location.href = "/";

        let params = new URLSearchParams(window.location.search);
        this.view = params.get("mode") === "signup" ? "signup" : "login";
        await this.service.render();
    }

    public async alert(message: string, status: string = 'error') {
        return await this.service.modal.show({
            title: "",
            message: message,
            cancel: false,
            actionBtn: status,
            action: '확인',
            status: status
        });
    }

    public async setView(view: string) {
        if (this.view === view || this.isTransitioning) return;

        this.isTransitioning = true;
        await this.service.render();

        window.setTimeout(async () => {
            this.view = view;
            let url = view === "signup" ? "/access?mode=signup" : "/access?mode=login";
            window.history.replaceState({}, "", url);
            this.isTransitioning = false;
            await this.service.render();
        }, 220);
    }

    public goHome() {
        location.href = "/";
    }

    public async login() {
        let user = JSON.parse(JSON.stringify(this.loginData));
        user.email = (user.email || "").trim();

        if (!user.email) {
            await this.alert("아이디를 입력해주세요.");
            return;
        }
        if (!user.password) {
            await this.alert("비밀번호를 입력해주세요.");
            return;
        }

        // user.password = this.service.auth.hash(user.password);

        this.submitting = true;
        await this.service.render();

        let { code, data } = await wiz.call("login", user);
        this.submitting = false;

        if (code == 200) {
            location.href = "/";
            await this.service.render();
        } else {
            await this.alert(data.message || "로그인에 실패했습니다.", 'error');
            await this.service.render();
        }
    }

    public onSignupIdChange() {
        this.idChecked = false;
        this.idAvailable = false;
    }

    public async checkId() {
        let email = (this.signupData.email || "").trim();
        if (!email) {
            await this.alert("아이디를 입력해주세요.");
            return;
        }

        this.checking = true;
        await this.service.render();

        let { code, data } = await wiz.call("check_id", { email });
        this.checking = false;

        if (code === 200) {
            this.idChecked = true;
            this.idAvailable = !!data.available;
            if (!this.idAvailable) await this.alert("이미 사용 중인 아이디입니다.");
        } else {
            await this.alert(data.message || "중복 확인에 실패했습니다.");
        }

        await this.service.render();
    }

    public async signup() {
        let user = JSON.parse(JSON.stringify(this.signupData));
        user.name = (user.name || "").trim();
        user.email = (user.email || "").trim();

        if (!user.name) {
            await this.alert("이름을 입력해주세요.");
            return;
        }
        if (!user.email) {
            await this.alert("아이디를 입력해주세요.");
            return;
        }
        if (!this.idChecked || !this.idAvailable) {
            await this.alert("아이디 중복확인을 해주세요.");
            return;
        }
        if (!user.password) {
            await this.alert("비밀번호를 입력해주세요.");
            return;
        }
        if (user.password.length < 8) {
            await this.alert("비밀번호는 8자 이상이어야 합니다.");
            return;
        }
        if (user.password !== user.passwordConfirm) {
            await this.alert("비밀번호가 일치하지 않습니다.");
            return;
        }

        this.submitting = true;
        await this.service.render();

        let { code, data } = await wiz.call("signup", {
            name: user.name,
            email: user.email,
            password: user.password
        });
        this.submitting = false;

        if (code === 200) {
            await this.alert("회원가입이 완료되었습니다. 로그인해주세요.", "success");
            this.loginData.email = user.email;
            this.loginData.password = "";
            this.signupData = { name: "", email: "", password: "", passwordConfirm: "" };
            this.idChecked = false;
            this.idAvailable = false;
            await this.setView("login");
        } else {
            await this.alert(data.message || "회원가입에 실패했습니다.");
            await this.service.render();
        }
    }
}

export default PageAccessComponent;